import styled from 'styled-components';
export const ErrorPage = styled.section`
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  padding: var(--space-xxl);
  background: var(--offWhite);
`;

export const ErrorCard = styled.div`
  width: min(100%, 460px);
  padding: var(--space-xxl);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-l);
  text-align: center;
`;

export const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;

  display: grid;
  place-items: center;

  background: linear-gradient(135deg, var(--yellow2), var(--orange4));

  color: var(--white);
  font-family: var(--headerFont);
  font-size: 2.5rem;
  font-weight: 700;
  box-shadow: var(--shadow-md);
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  h2 {
    margin: 0;
    color: var(--grey7);
    font-size: clamp(1.7rem, 4vw, 2.4rem);
    line-height: 1;
  }

  p {
    margin: 0;
    color: var(--grey4);
    font-size: 1rem;
    line-height: 1.6;
  }
`;

export const RetryButton = styled.button`
  border: none;
  border-radius: var(--borderRadiusButton);
  padding: var(--space-s) var(--space-xl);

  background: var(--orange5);
  color: var(--white);

  font-family: var(--mainFont);
  font-size: 0.95rem;
  font-weight: 700;

  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-md);
    background: var(--orange4);
  }

  &:active {
    transform: translateY(0);
  }
`;
